import { useMutation } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import type { CesuCheckResponse } from "types/cesu";
import {
    activateAiciRequest,
    activateCesuPlusRequest,
    checkCesuNumPeRequest,
    checkCesuNumSpRequest,
    generateCesuAttestationRequest,
    onlineSalaryDeclarationRequest,
} from "lib/api/cesu";

export const checkCesuNumSp = (num: string) =>
    parseResponse<CesuCheckResponse>(checkCesuNumSpRequest(num));

export const checkCesuNumPe = (num: string, birthday: string, providerCesu?: string) =>
    parseResponse<CesuCheckResponse>(checkCesuNumPeRequest(num, birthday, providerCesu));

export const onlineSalaryDeclaration = (bookingId: string) =>
    parseResponse<unknown>(onlineSalaryDeclarationRequest(bookingId));

export const activateCesuPlus = (bookingId: string) =>
    parseResponse<unknown>(activateCesuPlusRequest(bookingId));

export const activateAici = (bookingId: string) =>
    parseResponse<unknown>(activateAiciRequest(bookingId));

export const generateCesuAttestation = (bookingId: string) =>
    parseResponse<unknown>(generateCesuAttestationRequest(bookingId));

export const useOnlineSalaryDeclaration = () =>
    useMutation({
        mutationFn: (bookingId: string) => onlineSalaryDeclaration(bookingId),
    });

export const useActivateCesuPlus = () =>
    useMutation({
        mutationFn: (bookingId: string) => activateCesuPlus(bookingId),
    });

export const useActivateAici = () =>
    useMutation({
        mutationFn: (bookingId: string) => activateAici(bookingId),
    });

export const useGenerateCesuAttestation = () =>
    useMutation({
        mutationFn: (bookingId: string) => generateCesuAttestation(bookingId),
    });
